import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { DealcreatePage } from './dealcreate.page';

const routes: Routes = [
  {
    path: '',
    component: DealcreatePage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class DealcreatePageRoutingModule {}
